import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text" width="100%" theme="lightest" alignment="yes" className="py-0 text-align-left div-p-0 left-content accessibility-text-blade text-blade-header heading-accessibility" mdxType="TextBlock" />
    <h2 {...{
      "id": "interested-in-joining-the-beta-program-for-adobe-pdf-auto-redact-api"
    }}>{`Interested in joining the Beta Program for Adobe PDF Auto Redact API?`}</h2>
    <p>{`The Adobe PDF Auto-Redact tool accelerates the redaction of your documents by suggesting potential Personally Identifiable Information (PII) that you may want to remove from your document. `}<br />{`
You stay in full control by choosing whether the items identified by the AI-powered solution should be redacted, and you can manually add more fields to be redacted.`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <p>{`Once you are satisfied with which regions of the document need to be redacted, Adobe's secure redaction technology will ensure that the resulting PDF does not contain any trace of the redacted information in the newly created PDF.`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <p>{`Use this form to have an Adobe representative contact you with more information about the Beta program or to answer other questions you have about the product. For additional information, please write to `}<a parentName="p" {...{
        "href": "mailto:pdf-auto-redact-beta@adobe.com"
      }}>{`pdf-auto-redact-beta@adobe.com`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      